import { merge } from '../helper';

import objectOf from '../general/objectOf';

import * as exElement from './element';

// ----------------------------------------------------------------------------

function create(json: any, config?: Record<string, any>): HTMLElement {
    // Default Config
    const defConfig: Record<string, any> = {
        highlight: false,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (span)
    const elSpan = exElement.create({
        merge: defConfig,
        tag: 'span',
        style: {
            whiteSpace: 'pre',
            fontFamily: 'monospace',
        },
    });

    // Convert To Print
    json = convertToPrint(json, defConfig.convert);

    // If using highlight
    if (defConfig.highlight === true) {
        json = syntaxHighlight(json);
    }

    //
    elSpan.innerHTML = json;

    //
    return elSpan;
}

// ----------------------------------------------------------------------------

function parse(content: string): any {
    try {
        return JSON.parse(content);
    } catch (err) {
        // Do nothing
    }
}

function convertToPrint(json: any, config: Record<string, any> = {}): any {
    // Default Config
    const defConfig: Record<string, any> = {
        space: 4,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // If json is string
    if (objectOf(json) === 'String') {
        json = JSON.parse(json as string);
    }

    // If json is object
    if (objectOf(json) === 'Object') {
        json = JSON.stringify(json, null, defConfig.space);
    }

    //
    return json;
}

function syntaxHighlight(json: any): string {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        function (match): any {
            let cls = 'number';
            if (match.startsWith('"')) {
                if (match.endsWith(':')) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        },
    );
}

// ----------------------------------------------------------------------------

export { create, parse, convertToPrint };
